/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { LocoFeature } from '../../../loco/shared/model/loco-feature.model';

/**
 * @export
 * @class LmsLocoFeaturesComponent
 * @implements {OnInit}
 * @implements{OnDestroy}
 */
@Component({
  selector: 'lms-loco-features',
  templateUrl: './lms-loco-features.component.html',
  styleUrls: ['./lms-loco-features.component.scss']
})
export class LmsLocoFeaturesComponent implements OnInit, OnDestroy {


  @Input() listOfFeature: Array<LocoFeature>;
  @Input() locoLabel: any;

  /**
   * Creates an instance of LmsLocoFeaturesComponent.
   *
   * @memberOf LmsLocoFeaturesComponent
   */
  constructor() { }

  /**
   * @memberOf LmsLocoFeaturesComponent
   */
  ngOnInit() {
  }

  /**
   * @memberOf LmsLocoFeaturesComponent
   */
  ngOnDestroy() {
  }

}
